import { useQuery } from '../common';

// state === '123456789012345678901234567890', signup
// state === '111111', signin
// state === base64 { requestId }, submit-request

export function useSigninFlow() {
  return useQuery().get('state') === '111111';
}
